import { GiftIcon } from '@heroicons/react/24/solid'

type Props = {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  /** Giữ prop để tương thích chỗ gọi cũ */
  alt?: string
}

const SIZE: Record<NonNullable<Props['size']>, string> = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-10 w-10 sm:h-12 sm:w-12',
}

/**
 * Icon hộp quà KM — chỉ icon này nhấp nháy; chữ xung quanh giữ màu bình thường.
 */
const KmPromoIcon = ({ className = '', size = 'md', alt = 'Ưu đãi' }: Props) => {
  return (
    <GiftIcon
      aria-label={alt}
      className={`m2-km-icon shrink-0 text-m2-error ${SIZE[size]} ${className}`}
    />
  )
}

export default KmPromoIcon
